import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { GestaoFinanceiraService } from './gestao-financeira.service';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { IMyDpOptions } from 'mydatepicker';
import { DatatableService } from '../../../shared/services/datatable.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ModalBloqueioFinanceiroComponent } from './modal-bloqueio-financeiro/modal-bloqueio-financeiro.component';


export interface IFinancialBlockView {
  status: boolean;
  tipoBloqueio: string;
  dataAlteracao: Date;
  solicitante: string;
  motivo: string;
}

@Component({
  selector: 'ngx-gestao-financeira',
  templateUrl: './gestao-financeira.component.html',
  styleUrls: ['./gestao-financeira.component.scss']
})
export class GestaoFinanceiraComponent implements OnInit, OnDestroy {

  @ViewChild('myTable', {} as {
    read?: any;
    static: boolean;
  })
  public table: DatatableComponent;

  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  public formFaturaRecebtoEfetivo = null;
  public customLogin = null;
  public bloqueioFinanceiro: boolean = null;
  public openModal = false;
  public modalRef: NbDialogRef<ModalBloqueioFinanceiroComponent<IFinancialBlockView>> = null;
  public loading: boolean = true;
  public pageLimit: number = 10;

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
  };

  constructor(
    private formBuilder: FormBuilder,
    private service: GestaoFinanceiraService,
    private notificationsService: NotificationsService,
    private router: Router,
    private paginationService: SpringDatatablePaginationService,
    private dateUtilService: DateUtilService,
    private spinnerService: NgxSpinnerService,
    private datatableService: DatatableService,
    private dialogService: NbDialogService
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.formFaturaRecebtoEfetivo = this.formBuilder.group({
      dataInicio: null,
      dataFim: null,
    });

  }

  ngOnInit() {
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.table);
    this.hasFinancialBlock();
    this.handleGetFinancialBlockList();
  }

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.table)
  }

  hasFinancialBlock() {
    this.service.hasFinancialBlock({}, (response) => {
      this.spinnerService.show();
      this.bloqueioFinanceiro = response || false
      this.spinnerService.hide();
    }, (error) => {
      this.spinnerService.hide();
      this.notificationsService.error(error.message);
      this.loading = false;
    })
  }

  buildFilters(data?: any, page?: any) {
    let filters
    if (data) {
      if (data.dataInicio != null) {
        filters = {
          ...filters,
          dataInicio: this.dateUtilService
            .formatDate(new Date(data.dataInicio.date.year,
              data.dataInicio.date.month - 1,
              data.dataInicio.date.day),
              'YYYY-MM-DD')
        }
      }
      if (data.dataFim != null) {
        filters = {
          ...filters,
          dataFim: this.dateUtilService
            .formatDate(new Date(data.dataFim.date.year,
              data.dataFim.date.month - 1,
              data.dataFim.date.day),
              'YYYY-MM-DD')
        }
      }
    }

    filters = {
      ...filters,
      page,
      size: 10
    }

    return filters
  }

  handleGetFinancialBlockList(data?: any, page?: string) {
    this.spinnerService.show();

    this.service.findFinancialBlockList(
      this.buildFilters(data, page),
      ((response) => {

        this.datatablePagination.rowData = [null];
        this.datatablePagination.totalElements = 0;

        if (response.content.length === 0) {
          this.datatablePagination.rowData = [null];
          this.datatablePagination.totalElements = 0;
          this.notificationsService.alert('Dados não encontrados!')

        } else {
          this.paginationService.setInfo(response)
        }
        this.loading = false;
        this.spinnerService.hide();

      }), (error) => {
        this.spinnerService.hide();
        this.notificationsService.error(error.message);
        this.loading = false;
      });

  }

  clearPesquisaFaturas() {
    this.formFaturaRecebtoEfetivo = this.formBuilder.group({

      dataInicio: null,
      dataFim: null,

    });
    this.datatablePagination.rowData = [null];
    this.datatablePagination.totalElements = 0;
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  handleOpenModal() {
    this.modalRef = this.dialogService.open(ModalBloqueioFinanceiroComponent, {
      context: {
        bloqueioFinanceiro: this.bloqueioFinanceiro,
        observacao: ''
      }
    });

    this.modalRef.onClose.subscribe(() => this.ngOnInit())
  }
}
